import React from "react";
import { createRoot } from 'react-dom/client';
import ThreekitSingleProduct from "./Components/Threekit/ThreekitSingleProduct";
import { configureStore } from "@reduxjs/toolkit";
import { Provider } from "react-redux";
import fileSlice from "./Components/Threekit/redux/reducers/fileSlice";
import playerSlice from "./Components/Threekit/redux/reducers/playerSlice";
import threekitSlice from "./Components/Threekit/redux/reducers/threekitSlice";
import customizeSlice from "./Components/Threekit/redux/reducers/customizeSlice";
import fabricSlice from "./Components/Threekit/redux/reducers/fabricSlice";
import { createGlobalStyle } from "styled-components";
const GlobalStyle = createGlobalStyle`
  :root {
    --color-wine: #D9235F
  }
`;

const threekitElement = document.getElementById("threekit-root");
const root = createRoot(threekitElement);

export const threekitStore = configureStore({
  reducer: {
    files: fileSlice,
    playerState: playerSlice,
    threekit: threekitSlice,
    customize: customizeSlice,
    fabric: fabricSlice
  },
  trace: true
});

root.render(
<Provider store={threekitStore}>
  <GlobalStyle />
  <ThreekitSingleProduct />
</Provider>
);
